import { Flexbox, Form, QuickFilter } from '@/components'
import React from 'react'
import qs from 'qs'
import { useHistory, useLocation } from 'react-router-dom'
import useQuery from '@/hooks/useQuery'

function QuickFilterPeriodCastrations() {
  const query = useQuery()
  const history = useHistory()
  const location = useLocation()
  const dateRef = query?.s?.dateRef || 'createdAt'

  function handleChangeDateRef(newDateRef) {
    const newQuery = {
      ...query,
      s: { ...query.s, dateRef: newDateRef },
      page: 1,
    }
    history.replace({
      pathname: location.pathname,
      search: `?${qs.stringify(newQuery)}`,
    })
  }

  return (
    <QuickFilter
      initialValues={{ dateRef }}
      title="Filtrar relatório por data"
      autoSubmit
      renderForm={() => (
        <Flexbox.Column className="col-4 pt-2">
          <Form.Group>
            <Form.Label className="label-sm pt-2" htmlFor="dateRef">
              Selecione o período de referência para o relatório
            </Form.Label>
            <Form.ValidationField name="dateRef">
              {({ field }) => (
                <Form.Select
                  // eslint-disable-next-line react/jsx-props-no-spreading
                  {...field}
                  id="dateRef"
                  className="select-sm"
                  placeholder="Data de referência"
                  onChange={(e) => {
                    field.onChange(e)
                    handleChangeDateRef(e.target.value)
                  }}
                >
                  <option value="createdAt">Solicitado em (padrão)</option>
                  <option value="approvedAt">Aprovado em</option>
                  <option value="canceledAt">Cancelado em</option>
                  <option value="startedAt">Iniciado em</option>
                  <option value="performedAt">Finalizado em</option>
                  <option value="scheduledTo">Agendado para</option>
                  <option value="rejectedAt">Rejeitado em</option>
                  <option value="preApprovedAt">Pré aprovado em</option>
                </Form.Select>
              )}
            </Form.ValidationField>
          </Form.Group>
        </Flexbox.Column>
      )}
    />
  )
}

export default QuickFilterPeriodCastrations
